import React from 'react'

function ManageUserCheckBox({ id, checked, onChange }) {


  return (
    <label className="relative flex cursor-pointer items-center rounded mr-2">

      <input
        checked={checked}
        onChange={onChange}
        id={id}
        type="CheckBox" className={`peer cursor-pointer appearance-none relative h-[15px] w-[15px] bg-white 
                ${checked ? " hover:bg-[#36ff87]" : " hover:bg-lightPrimary"} border border-gray-300 transition-all checked:bg-headPrimary rounded`}
      />

      <div className="pointer-events-none group absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity peer-checked:opacity-100">
        <svg xmlns="http://www.w3.org/2000/svg" className={`h-3 w-3 text-gray-900 hover:text-white ${checked ? "" : ""}`} viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
        </svg>
      </div>

    </label>
  )
}

export default ManageUserCheckBox